import React, { useEffect, useRef } from "react";
import "../utils/quilMention.js";
import { Quill } from "react-quill";
// import 'quill-mention';
import "quill/dist/quill.snow.css"; // Import Quill stylesheet
import axiosClient from "../../../utils/axios";
import { resolve } from "../../../api/endPoints";
import * as PropTypes from "prop-types";

const CustomQuillEditor = ({
  quillEditor,
  setQuillEditor,
  locationUUID,
  messageSettings,
  onEnter = () => {},
  msg,
  setMsg,
  editorStyle,
  activeMention,
  readOnly
}) => {
  const getLocationsUsers = async (search) => {
    const url = resolve(
      'members_list',
      {},
      { location_uuid: locationUUID, search }
    );
    const res = await axiosClient.get(url);
    const data = res.data.results;
    const users = data.map((user) => {
      return { ...user, display_name: `@${user.display_name}` };
    });
    return users;
  };
  const getMention = () => {
    return {
      allowedChars: /^\w+$/,
      mentionDenotationChars: ["@"],
      minChars: 1,
      maxChars: 180,
      isolateCharacter: true,
      showDenotationChar: true,
      spaceAfterInsert: true,
      mentionContainerClass: " zindex-5 ",
      mentionListClass: "bg-light-secondary rounded list-unstyled ",
      listItemClass: "  ",
      dataAttributes: ["id", "uuid", "display_name", "show_denotation_char"],
      mentionListStyleOptions:
        "max-height:15em; overflow-y:scroll; margin:0; padding:0;",
      mentionContainerClassOptions: ["rounded", "bg-light-secondary"],
      mentionContainerStyleOptions: "padding: 5px 3px;",
      renderItem: function (item) {
        const element = `<div class="d-flex cursor-pointer mb-1 rounded bg-white mx-2">
                        <!--begin::Symbol-->
                        <div class="px-2 py-2 bg-white mx-2 rounded">
                          <span class="h-20px w-20px text-success fw-bold text-uppercase">${item.initials}</span>
                        </div>
                        <!--end::Symbol-->
                        <!--begin::Text-->
                        <div class="d-flex align-items-center">
                          <div class=" me-3">${item.display_name}</div>
                        </div>
                        <!--end::Text-->
                      </div>`;
        return element;
      },
      renderLoading: function () {
        return '<div class="d-flex"><div class="spinner-border text-primary spinner-border-sm" role="status"></div></div>';
      },
      source: async function (searchTerm, renderList, mentionChar) {
        const uniqueValues = await getLocationsUsers(searchTerm);
        renderList(uniqueValues, searchTerm);
      },
    };
  };
  const Quillref = useRef(null);
  useEffect(() => {
    const prviousInstanceData = quillEditor?.getContents();
    if (quillEditor) {
      // destroy the previous instance
      quillEditor?.off("editor-change");
    }
    const modules = {
      toolbar: false,
    };
    if (activeMention) {
      modules.mention = getMention();
    }
    const editor = new Quill(Quillref.current, {
      theme: "snow",
      readOnly,
      modules,
    });
    setQuillEditor(editor);
    // If you need to set initial content or handle content changes
    editor.setContents(prviousInstanceData);
    editor.on("text-change", () => {
      const html = editor.root.innerHTML;
      setMsg(html); // Or however you wish to handle the changed content
    });
    // Apply custom styles if necessary
    Object.assign(Quillref.current.style, {
      width: "100%",
      border: "none",
      outline: "none",
      padding: "5px",
      fontSize: "15px",
      backgroundColor: messageSettings?.is_internal_note ? "#fff8dd" : "white",
      // height: '100%', // Set fixed height or adapt as needed
      ...editorStyle,
    });
  }, [activeMention]);
  useEffect(() => {
    const modules = {
      toolbar: false,
    };
    if (activeMention) {
      modules.mention = getMention();
    }
    const editor = new Quill(Quillref.current, {
      theme: "snow",
      readOnly,
      modules,
    });
    setQuillEditor(editor);

    // If you need to set initial content or handle content changes
    editor.setContents(msg);

    editor.on("text-change", () => {
      const html = editor.root.innerHTML;
      setMsg(html); // Or however you wish to handle the changed content
    });

    // Apply custom styles if necessary
    Object.assign(Quillref.current.style, {
      width: "100%",
      border: "none",
      outline: "none",
      padding: "5px",
      fontSize: "14px",
      height: "100%",
      // Set fixed height or adapt as needed
      ...editorStyle,
    });
    // activeConversation, messageSettings, msg, setMsg, editorStyle
    return () => {
      editor.off("text-change");
    };
  }, []); // Ensure effect runs on dependency change

  if (!Quill) return <></>;
  return (
    <div
      ref={Quillref}
      style={{ ...editorStyle }}
      className={`custom-editor ${
        messageSettings?.is_internal_note ? "internal-note" : ""
      }`}
    ></div>
  );
};

export default CustomQuillEditor;

CustomQuillEditor.propTypes = {
  quillEditor: PropTypes.any,
  setQuillEditor: PropTypes.func,
  locationUUID: PropTypes.string,
  messageSettings: PropTypes.object,
  msg: PropTypes.any,
  setMsg: PropTypes.func,
  editorStyle: PropTypes.object,
  activeMention: PropTypes.bool,
  readOnly: PropTypes.bool,
  onEnter: PropTypes.func,
};
